<template>
  <div class="third">
    <component :is="labelName" :ref="labelName" @addYuanxi="toAddRole" @backHome="goBackHome"></component>
  </div>
</template>

<script>
import userManageIndex from "./components/userMan.vue";
import userManageDetails from "./components/details.vue";

export default {
  name: "userMan",
  data() {
    return {
      labelName: "userManageIndex"
    };
  },
  components: {
    userManageIndex,
    userManageDetails
  },
  mounted() {
    //罗伟加的
    console.log("this.$route.query.id", this.$route.query.id);
    if (this.$route.query.id) {
      this.labelName = "userManageDetails";
      sessionStorage.setItem("detailsUserID", this.$route.query.id);
      sessionStorage.setItem("goBack", "back");
    }
    //-----------------
  },
  methods: {
    // 返回首页
    goBackHome() {
      this.labelName = "userManageIndex";
    },
    // 详情
    toAddRole(val) {
      this.labelName = "userManageDetails";
    }
  }
};
</script>
